import LayoutCentered from '@/layouts/LayoutCentered.vue'
import LayoutEmpty from '@/layouts/LayoutEmpty.vue'
import LayoutDefault from '@/layouts/LayoutDefault.vue'
import InnerContent from '@/components/InnerContent.vue'
import bhUsersPaths from '@/router/paths/bhUsersPaths'
import practicesPaths from '@/router/paths/practicesPaths'
import chatPaths from '@/router/paths/chatPaths'
import libraryPaths from '@/router/paths/libraryPaths'
import templatesPaths from '@/router/paths/templatesPaths'
// import activitiesPaths from "@/router/paths/activitiesPaths"
import exercisesPaths from '@/router/paths/exercisesPaths'
import screenersPaths from '@/router/paths/screenersPaths'
import coursesPaths from '@/router/paths/coursesPaths'
import Config from '@/config.json'
import { tenantTexts } from '@/mixins/tenantTexts'
import adminPanelPaths from './paths/adminPanelPaths'

const publicScreenerEnabled =
  (Config.VUE_FEATURE_SCREENER === true ||
    Config.VUE_FEATURE_SCREENER === 'true') &&
  (Config.VUE_FEATURE_PUBLIC_SCREENER === true ||
    Config.VUE_FEATURE_PUBLIC_SCREENER === 'true')

export const publicRoute = [
  {
    path: '*',
    component: () => import('@/views/error/NotFound.vue'),
  },
  {
    path: '/',
    name: 'Login',
    component: LayoutEmpty,
    children: [
      {
        path: '',
        component: () => import('@/views/Login.vue'),
      },
    ],
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: LayoutCentered,
    meta: {
      title: 'Reset password',
    },
    children: [
      {
        path: '',
        component: () => import('@/views/ResetPassword.vue'),
      },
    ],
  },
  Config.VUE_TENANT_ID === 'olympianbydesign'
    ? {
        path: '/privacy',
        name: 'PrivacyPolicy',
        component: LayoutEmpty,
        meta: {
          title: 'Privacy policy',
        },
        children: [
          {
            path: '',
            component: () => import('@/views/PrivacyPolicy.vue'),
          },
        ],
      }
    : {
        path: '*',
      },
  {
    path: '/404',
    name: '404',
    meta: {
      title: 'Not Found',
    },
    component: () => import('@/views/error/NotFound.vue'),
  },
  publicScreenerEnabled
    ? {
        path: '/screener',
        name: 'ScreenerForm',
        component: () => import('@/views/ScreenerForm.vue'),
        meta: {
          title: 'Screener',
        },
        props: {
          screenerVersion: 1,
          publicKey: 'XyZh',
        },
      }
    : {
        path: '*',
      },
  publicScreenerEnabled
    ? {
        path: '/summit',
        name: 'ScreenerForm',
        component: () => import('@/views/ScreenerForm.vue'),
        meta: {
          title: 'Screener',
        },
        props: {
          screenerVersion: 2,
          publicKey: 'gHeA',
        },
      }
    : {
        path: '*',
      },
  publicScreenerEnabled
    ? {
        path: '/exos',
        name: 'ScreenerForm',
        component: () => import('@/views/ScreenerForm.vue'),
        meta: {
          title: 'Screener',
        },
        props: {
          skipSubmitForm: true,
          screenerVersion: 1,
          screenerHasAdditionalScores: true,
          publicKey: 'ExZ5',
        },
      }
    : {
        path: '*',
      },
  publicScreenerEnabled
    ? {
        path: '/survey',
        name: 'ScreenerForm',
        component: () => import('@/views/ScreenerForm.vue'),
        meta: {
          title: 'Mind Trap Survey',
          rootTitle: 'The Rise Framework',
          favicon:
            'https://theriseframework.com/wp-content/uploads/2024/06/cropped-the_rise_framework_logo-32x32.jpg',
        },
        props: {
          skipSubmitForm: true,
          screenerVersion: 1,
          publicKey: 'HwX8',
          isTheRiseFrameworkSurvey: true,
        },
      }
    : {
        path: '*',
      },
]

export const protectedRoute = [
  {
    path: '/',
    component: LayoutDefault,
    hidden: true,
    meta: {
      title: 'Login',
      icon: '',
    },
    redirect: '/participants',
  },
  {
    path: '/dashboard',
    name: 'Participants Dashboard',
    meta: {
      title: `Dashboard`,
      icon: 'bhi-home',
      requiresAuth: true,
    },
    hideOnRole: [1, 2, 3, 4, 6, 7],
    hideOnRoleAlsoAdmins: true,
    component: () => import('@/views/ParticipantsDashboard.vue'),
  },
  {
    path: '/advisors-dashboard',
    name: 'Advisors Dashboard',
    meta: {
      title: `Dashboard`,
      icon: 'bhi-home',
      requiresAuth: true,
    },
    hideOnRole: [1, 2, 3, 5, 6, 7],
    hideOnRoleAlsoAdmins: true,
    component: () => import('@/views/AdvisorsDashboard.vue'),
  },
  {
    path: '/advisors-dashboard/:id',
    name: 'Advisors Dashboard Details',
    hidden: true,
    meta: {
      title: `Advisors Dashboard`,
      requiresAuth: true,
    },
    component: () => import('@/views/AdvisorsDashboardDetails.vue'),
  },
  {
    path: '/participants',
    name: 'Patients',
    meta: {
      title: 'Participants',
      icon: 'bhi-account-multiple',
      requiresAuth: true,
    },
    hideOnRole: 7,
    component: () => import('@/views/Patients.vue'),
  },
  {
    path: '/participants/:id',
    name: 'Patient',
    hidden: true,
    meta: {
      title: 'Participants',
      requiresAuth: true,
    },
    redirect: {
      name: 'Patient General',
    },
    component: () => import('@/views/Patient.vue'),
    children: [
      {
        path: '/participants/:id/general',
        name: 'Patient General',
        meta: {
          menuTitle: 'General',
          title: 'Participant',
          icon: 'bhi-home',
          requiresAuth: true,
          disableLink: true,
        },
        component: () => import('@/views/patients/PatientGeneral.vue'),
      },
      {
        path: '/participants/:id/routines-progress',
        name: 'Patient Exercises Report',
        meta: {
          menuTitle: 'Progress',
          title: 'Participant',
          icon: 'bhi-reports',
          requiresAuth: true,
          disableLink: true,
        },
        component: () => import('@/views/patients/PatientExercisesReport.vue'),
      },
      {
        path: '/participants/:id/chat',
        name: 'Patient Chat',
        meta: {
          menuTitle: 'Messages',
          title: 'Participant',
          icon: 'bhi-forum',
          requiresAuth: true,
          disableLink: true,
        },
        component: () => import('@/views/patients/ChatWrapper.vue'),
      },
      {
        path: '/participants/:id/journal',
        name: 'Patient Journal',
        availableParticipantFeatureFlag: 'journalAvailable',
        meta: {
          menuTitle: 'Journal',
          title: 'Participant',
          icon: 'bhi-book',
          requiresAuth: true,
          disableLink: true,
        },
        component: () => import('@/views/patients/PatientJournal.vue'),
      },
      {
        path: '/participants/:id/swaps',
        name: 'Participant Swaps',
        availableParticipantFeatureFlag: 'swapAvailable',
        meta: {
          menuTitle: tenantTexts.participantNavigation.swaps.menuTitle,
          title: tenantTexts.participantNavigation.swaps.title,
          icon: 'bhi-swaps',
          requiresAuth: true,
          disableLink: true,
        },
        component: () => import('@/views/patients/PatientSwaps.vue'),
        children: [
          {
            path: '/participants/:id/swaps/:swapid',
            name: 'Participant Swap',
            availableParticipantFeatureFlag: 'swapAvailable',
            meta: {
              icon: 'bhi-swaps',
              requiresAuth: true,
              disableLink: true,
              root: true,
            },
            component: () => import('@/views/patients/PatientSwap.vue'),
          },
        ],
      },
      {
        path: '/participants/:id/routines',
        name: 'Patient Exercises',
        meta: {
          menuTitle: tenantTexts.participantNavigation.routines.menuTitle,
          title: tenantTexts.participantNavigation.routines.title,
          icon: 'bhi-pulse',
          requiresAuth: true,
          disableLink: true,
        },
        component: () => import('@/views/patients/PatientExercises.vue'),
      },
      {
        path: '/participants/:id/sprints',
        name: 'Patient Timed release',
        meta: {
          menuTitle: 'Sprints',
          title: 'Participant',
          icon: 'bhi-clock',
          requiresAuth: true,
          disableLink: true,
        },
        component: () => import('@/views/patients/PatientTimedRelease.vue'),
      },
      {
        path: '/participants/:id/user-library',
        name: 'Patient Media',
        meta: {
          menuTitle: 'Media',
          title: 'Participant',
          icon: 'bhi-book-open',
          requiresAuth: true,
          disableLink: true,
        },
        component: () => import('@/views/patients/PatientMedia.vue'),
      },
      {
        path: '/participants/:id/smart-survey',
        name: 'Patient Smart Survey',
        enabledFeatures: ['VUE_FEATURE_SMART_SURVEY'],
        availableParticipantFeatureFlag: 'smartSurveyAvailable',
        meta: {
          menuTitle: tenantTexts.participantNavigation.smartSurvey.menuTitle,
          title: tenantTexts.participantNavigation.smartSurvey.title,
          icon: 'bhi-content-paste',
          requiresAuth: true,
          disableLink: true,
        },
        component: () => import('@/views/patients/PatientSmartSurvey.vue'),
      },
      {
        path: '/participants/:id/screeners',
        name: 'Patient Screeners',
        meta: {
          menuTitle: 'Screeners',
          title: 'Participant',
          icon: 'bhi-content-paste',
          requiresAuth: true,
          disableLink: true,
        },
        enabledFeatures: ['VUE_FEATURE_SCREENER'],
        availableParticipantFeatureFlag: 'surveyAvailable',
        component: () => import('@/views/patients/PatientScreeners.vue'),
      },
      {
        path: '/participants/:id/courses',
        name: 'Patient Courses',
        meta: {
          menuTitle: 'Courses',
          title: 'Participant',
          icon: 'bhi-mortarboard',
          requiresAuth: true,
          disableLink: true,
        },
        component: () => import('@/views/patients/PatientCourses.vue'),
        children: [
          {
            path: '/participants/:id/courses/:courseid',
            name: 'Patient Course',
            meta: {
              root: true,
              icon: 'bhi-mortarboard',
              requiresAuth: true,
              disableLink: true,
            },
            component: () => import('@/views/patients/PatientCourse.vue'),
          },
        ],
      },
      {
        path: '/participants/:id/journeys',
        name: 'Patient Journeys',
        meta: {
          menuTitle: 'Journeys',
          title: 'Participant',
          icon: 'bhi-milestone',
          requiresAuth: true,
          disableLink: true,
        },
        component: () => import('@/views/patients/PatientJourneys.vue'),
      },
    ],
  },
  {
    path: '/profile',
    name: 'Profile',
    hidden: true,
    meta: {
      title: 'Profile',
      requiresAuth: true,
    },
    component: () => import('@/views/Profile.vue'),
    children: [
      {
        path: '/profile/general',
        name: 'Profile General',
        meta: {
          menuTitle: 'General',
          title: 'Profile',
          icon: 'bhi-home',
          requiresAuth: true,
          disableLink: true,
        },
        component: () => import('@/views/profile/ProfileGeneral.vue'),
      },
      {
        path: '/profile/quick-messages',
        name: 'Profile Quick messages',
        meta: {
          menuTitle: 'Quick messages',
          title: 'Profile',
          icon: 'bhi-message',
          requiresAuth: true,
          disableLink: true,
        },
        component: () => import('@/views/profile/ProfileQuickMessages.vue'),
      },
    ],
  },
  {
    path: '/notifications',
    name: 'Notifications',
    hidden: true,
    meta: {
      title: 'Notifications',
      requiresAuth: true,
    },
    component: () => import('@/views/Notifications.vue'),
  },
  {
    path: '/notifications-grouped',
    name: 'NotificationsGrouped',
    hidden: true,
    meta: {
      title: 'Notifications',
      requiresAuth: true,
    },
    component: () => import('@/views/NotificationsGrouped.vue'),
  },
  ...practicesPaths,
  ...bhUsersPaths,
  ...chatPaths,
  ...libraryPaths,
  ...templatesPaths,
  // ...activitiesPaths,
  ...exercisesPaths,
  ...screenersPaths,
  ...coursesPaths,
  ...adminPanelPaths,
]
